import { Routes, Route, Link, useLocation } from "react-router-dom";
import Announcements from "./Announcements";
import SectionActivities from "./SectionActivities";
import NewPostPage from "./NewPost";
import Events from "./Events";
import ProfileSetup from "./ProfileSetup";
import Home from "./Home";
import club_logo from '../images/platform_logo.png'
import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { MenuContext } from '../context/MenuContext';
import { AiOutlineClose } from "react-icons/ai";

export default function Dashboard() {
  const location = useLocation();
  const {userProfile, logOutFunction} = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className={`transition-transform duration-500 fixed lg:relative top-0 bottom-0 z-[50] lg:z-[0] w-64 bg-gray-800 text-white p-6 space-y-4 ${menuOpen ? 'flex' : 'hidden lg:flex'} flex-col justify-start`}>
        <div className='flex flex-col justify-start items-center gap-y-2 w-full mt-[10px] mb-[30px]'>
            <div
                onClick={() => setMenuOpen(false)}
                className="block lg:hidden btn btn-ghost btn-circle mb-4 self-end fixed"
            >
                <AiOutlineClose className="h-7 w-7 text-dark" />
            </div>
            <img src={club_logo} className="h-[80px] rounded-full" alt="logo" />
            <h2 className="text-md font-bold">Aadedeji Admin Portal</h2>
        </div>
        <nav className="flex flex-col space-y-2 gap-y-1">
          <Link to="/dashboard/home" className={`py-2 px-3 hover:bg-gray-600 hover:font-semibold rounded-[7px] ${(location.pathname == "/dashboard/home") && 'bg-gray-700'}`} >Home</Link>
          <Link to="/dashboard/create-post" className={`py-2 px-3 hover:bg-gray-600 hover:font-semibold rounded-[7px] ${(location.pathname == "/dashboard/create-post") && 'bg-gray-700'}`} >Publish Post</Link>
          <div className={`flex items-center justify-start py-2 px-3 hover:bg-secondary rounded-[7px] text-white cursor-pointer`}>
            Manage Gallery
            <div className="ml-2 py-1 px-2 rounded-[5px] bg-blue-600 text-white font-semibold text-xs">
              <a>soon!</a>
            </div>
          </div>
          <div className={`flex items-center justify-start py-2 px-3 hover:bg-secondary rounded-[7px] text-white cursor-pointer`}>
            Manage Team
            <div className="ml-2 py-1 px-2 rounded-[5px] bg-blue-600 text-white font-semibold text-xs">
              <a>soon!</a>
            </div>
          </div>
          <div onClick={() => logOutFunction()} className={`py-2 px-3 hover:opacity-[0.8] text-[#ff0000] cursor-pointer hover:font-semibold rounded-[7px]`}>
            Log Out
          </div>
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-0 bg-gray-50">
        <Routes>
          <Route path="home" element={<Home />} />
          <Route path="create-post" element={<NewPostPage />} />
        </Routes>
      </main>
    </div>
  );
}
